export default "__VITE_ASSET__Dj42GRG___"